// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8a7970aa","488":"a856ab5b","977":"e34309cf"}[chunkId] + ".chunk.js";
};